import {UNIT_COEF, UNIT_MILLIMETER} from "./constants";

export function getLayersObjects(type, layers) {
    const _types = ['areas', 'lines', 'vertices'];
    let objects = [];

    if (!_types.includes(type)) return [];

    Object.keys(layers).forEach((layerID) => {
        objects = objects.concat(Object.values(layers[layerID][type]));
    });

    return objects;
}

export function prepareOptions(defaultOptions, inputOptions) {
    Object.keys(defaultOptions).forEach((key) => {
        if (inputOptions.hasOwnProperty(key)) defaultOptions[key] = inputOptions[key];
    });

    return defaultOptions;
}

export function getVertexRenderCoords(vertex, unit = UNIT_MILLIMETER) {
    let {x, y} = vertex;
    let coef = UNIT_COEF[unit];

    return {x: x * coef, y: y * coef};
}

export function converVerticesObjToArr(vertices) {
    let ver = [];

    for(let i in vertices){
        ver.push({x: vertices[i][0], y: vertices[i][1]})
    }

    return ver;
}

export function get2dCoord(vertices, element) {
    let res = [];

    element.vertices.forEach((vertex) => {
        let [bottom, top] = vertices[vertex]['2d'];
        res.push({bottom, top});
    });

    return res;
}

export function getExtremeValue(obj, ignore = '') {
    let maxValue = -Infinity;
    let minValue = Infinity;
    let maxKey = '';
    let minKey = '';

    Object.keys(obj).forEach((_key) => {
        if ((obj[_key] < maxValue) && (obj[_key] > minValue) || ignore === _key) return;

        if (obj[_key] < minValue) {
            minValue = obj[_key];
            minKey = _key;
        }

        if (obj[_key] > maxValue) {
            maxValue = obj[_key];
            maxKey = _key;
        }
    });

    return {maxValue, minValue, maxKey, minKey}
}
